var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Header, Label } from "semantic-ui-react";
import { ORIGIN } from "../Config";
import proteinLogo from '../images/logo_Protein.png';
import rnaLogo from '../images/logo_RNA.png';
import KitDisplay from "../kit/rna-fish/KitDisplay";
import { AutomatedProKit, ManualGoldIfKit, ManualProKit, RnaFishKit, SecondaryIfKit } from "./rna-fish/KitModel";
var KitIndexHeader = /** @class */ (function (_super) {
    __extends(KitIndexHeader, _super);
    function KitIndexHeader(props) {
        return _super.call(this, props) || this;
    }
    KitIndexHeader.prototype.render = function () {
        var imgPath;
        var altText;
        if (this.props.kit instanceof SecondaryIfKit || this.props.kit instanceof ManualGoldIfKit) {
            imgPath = proteinLogo;
            altText = 'Protein logo';
        }
        else {
            imgPath = rnaLogo;
            altText = 'RNA logo';
        }
        var productName = this.props.kit instanceof AutomatedProKit
            ? ""
            : productNameForKit(this.props.kit, this.props.adminView);
        var titleSeparator = this.props.kit instanceof AutomatedProKit ? "" : ":";
        return React.createElement(Grid, { className: 'kit-index-header' },
            React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                    React.createElement(Header, { className: 'kit-num', title: this.props.title },
                        React.createElement("span", { className: 'kit-index-kit-number' },
                            "Kit ",
                            this.props.itemIndex + 1,
                            titleSeparator),
                        productName && React.createElement("span", { className: 'kit-index-product-name' },
                            " ",
                            productName),
                        this.props.kit.starterKit &&
                            React.createElement(Label, { className: 'starter-kit-tag', size: 'mini' }, "Starter Kit"))),
                ORIGIN === "mi" && React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                    React.createElement("img", { className: 'kit-index-logo', src: imgPath, alt: altText }))));
    };
    return KitIndexHeader;
}(React.PureComponent));
export default KitIndexHeader;
export function productNameForKit(kit, adminView) {
    if (kit instanceof RnaFishKit) {
        return kit.legacy ? "HCR™ RNA-FISH (v3.0)" : "HCR™ Gold RNA-FISH";
    }
    else if (kit instanceof SecondaryIfKit) {
        return kit.legacy ? "HCR™ 2ºIF" : "HCR™ Gold 2ºIF";
    }
    else if (kit instanceof ManualProKit) {
        return adminView ? "HCR™ Manual Pro RNA-ISH" : "HCR™ Pro RNA-ISH";
    }
    else if (kit instanceof ManualGoldIfKit) {
        return "HCR™ Gold IF";
    }
    else if (kit instanceof AutomatedProKit) {
        return "HCR™ Pro RNA-ISH";
    }
    else {
        return "";
    }
}
//# sourceMappingURL=KitIndexHeader.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/KitIndexHeader.js
// module id = 209
// module chunks = 0